import { render } from "./Inspections.vue?vue&type=template&id=f8d4bf82"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__